export const CREATORS = [
  'bokuwanco',
  // 'shirobe_xx',
  'koharubiyori_51',
  'natsuko',
  'Nonax299',

  'nawowcow',
  'tsunaegg',
  'cott0n_x',
  'purimipurioka',
  'RiU__Sky',
] as const
export type CREATOR = (typeof CREATORS)[number]

export const creatorMapTargetId: Record<CREATOR, string> = {
  koharubiyori_51: 'valorant1',
  natsuko: 'valorant2',
  Nonax299: 'valorant3',
  bokuwanco: 'valorant4',
  nawowcow: 'valorant5',
  tsunaegg: 'valorant6',
  // shirobe_xx: 'valorant7',
  cott0n_x: 'valorant8',
  purimipurioka: 'valorant9',
  RiU__Sky: 'valorant10',
}

export const mapCreatorInfo: Record<
  CREATOR,
  {
    profileCardImageURL: string
    creatorImageURL: string
  }
> = {
  Nonax299: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['Nonax299']}/0.jpg`,
    creatorImageURL: '',
  },
  natsuko: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['natsuko']}/0.jpeg`,
    creatorImageURL: '',
  },
  koharubiyori_51: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['koharubiyori_51']}/0.jpg`,
    creatorImageURL: '',
  },
  bokuwanco: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['bokuwanco']}/0-min.png`,
    creatorImageURL: '',
  },
  nawowcow: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['nawowcow']}/0-min.jpg`,
    creatorImageURL: '',
  },
  tsunaegg: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['tsunaegg']}/0-min.jpg`,
    creatorImageURL: '',
  },
  // shirobe_xx: {
  //   profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['shirobe_xx']}/0-min.jpg`,
  //   creatorImageURL: '',
  // },
  cott0n_x: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['cott0n_x']}/0-min.jpg`,
    creatorImageURL: '',
  },
  purimipurioka: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['purimipurioka']}/0.jpg`,
    creatorImageURL: '',
  },
  RiU__Sky: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['RiU__Sky']}/0.jpg`,
    creatorImageURL: '',
  },
}
